export const BatchModel = {
  id: "",
  batch: "",
  expiry_date: "",
  manufacture_date: "",
  purchasing_price: 0,
  selling_price: 0,
};

export class BatchDecorator {
  constructor(batch) {
    this.batch = batch;
  }

  toRequest() {
    return {
      id: this.batch.id,
      batch: this.batch.batch,
      expiry_date: this.batch.expiry_date,
      manufacture_date: this.batch.manufacture_date,
      purchasing_price: this.batch.purchasing_price,
      selling_price: this.batch.selling_price,
    };
  }
}
